import { expandLinesAdapter } from '../../adapters/expand_lines.js?vue3';
import { optionsMenuAdapter } from '../../adapters/options_menu.js?vue3';
import { toggleFileAdapter } from '~/rapid_diffs/adapters/toggle_file';
import { disableDiffSideAdapter } from '~/rapid_diffs/adapters/disable_diff_side';
import { imageAdapter } from '../../adapters/image_viewer.js?vue3';
import { loadFileAdapter } from '../../adapters/load_file.js?vue3';
import { lineLinkAdapter } from '~/rapid_diffs/adapters/line_link';

export const HEADER_ADAPTERS = [optionsMenuAdapter, toggleFileAdapter, loadFileAdapter];

export const VIEWER_ADAPTERS = {
  text_inline: [...HEADER_ADAPTERS, expandLinesAdapter, lineLinkAdapter],
  text_parallel: [...HEADER_ADAPTERS, expandLinesAdapter, disableDiffSideAdapter, lineLinkAdapter],
  image: [...HEADER_ADAPTERS, imageAdapter],
  no_preview: [...HEADER_ADAPTERS],
};
